
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useSEO, generateWebPageSchema } from '../../utils/seo';

export default function AboutPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  // Apply SEO meta tags
  useSEO({
    title: 'About DN Biotech | Research Peptide Supplier for Laboratories',
    description:
      'Learn about DN Biotech, your trusted partner for high-purity research peptides and biotech compounds. Quality-first approach with pharmaceutical‑grade standards and expert support.',
    keywords:
      'about DN Biotech, research peptide supplier, laboratory supply company, biotech compounds supplier, peptide quality standards',
    canonical: `${siteUrl}/about`,
    schema: generateWebPageSchema(
      siteUrl,
      '/about',
      'About DN Biotech | Research Peptide Supplier for Laboratories',
      'Learn about DN Biotech, your trusted partner for high-purity research peptides and biotech compounds. Quality‑first approach with pharmaceutical‑grade standards and expert support.'
    ),
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="pt-32 pb-16 bg-gradient-biotech">
        <div className="container-custom text-center">
          <div
            className="inline-flex items-center gap-2.5 px-4 py-2 bg-white/10 backdrop-blur-md rounded-full border border-white/20 mb-6"
            aria-label="DN Bio Research"
          >
            <svg
              className="w-4 h-4 text-primary-400"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 3v18" />
              <path d="M6 6c0 3.5 2.5 6 6 6s6-2.5 6-6" />
              <path d="M6 18c0-3.5 2.5-6 6-6s6 2.5 6 6" />
              <circle cx="6" cy="6" r="1.5" fill="currentColor" />
              <circle cx="18" cy="6" r="1.5" fill="currentColor" />
              <circle cx="6" cy="18" r="1.5" fill="currentColor" />
              <circle cx="18" cy="18" r="1.5" fill="currentColor" />
              <circle cx="12" cy="12" r="1.5" fill="currentColor" />
            </svg>
            <span className="text-white text-sm font-semibold tracking-wide">
              DN Bio Research
            </span>
          </div>
          <h1 className="text-white mb-6">About DNBio</h1>
          <p className="text-xl text-gray-200 leading-relaxed max-w-2xl mx-auto">
            Your trusted partner for high-purity research peptides and biotech
            compounds
          </p>
        </div>
      </section>

      {/* ----------------------------------------------------------------
           Add the rest of the page content here.
           For now we insert a simple placeholder to keep the JSX well‑formed.
      ---------------------------------------------------------------- */}
      <section className="py-12">
        <div className="container-custom text-center">
          <p className="text-gray-700">
            {/* Placeholder content – replace with actual page sections */}
            More information about DN Biotech will be added here.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
